/* global localStorage */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H1, Typography, Image, Button as BaseButton, LinkText } from '../components';
import KitCarousel from '../components/KitCarousel';
import cardsList from '../lib/agent-kit/cards-list';
import { colors } from '../utils';
import { ROUTES, SKIP_AGENT_KIT_NEXT_LOGIN } from '../Constants';

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FaqText = styled(Typography)`
  font-size: 12px;
  color: ${colors.g04};
  a {
    color: ${colors.b01};
  }
`;

const Button = styled(BaseButton)`
  max-width: 194px;
`;

const Title = styled(H1)`
  color: ${colors.b01};
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 8px;
`;

const Subtitle = styled(Typography)`
  color: ${colors.g04};
  text-align: center;
  margin-bottom: 24px;
`;

const Card = styled.div`
  cursor: pointer;
  min-width: 250px;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.w01};
  border-radius: 8px;
  padding: 24px 16px;
  margin-bottom: 16px;
  transition: all 0.15s ease;

  img {
    margin-bottom: 8px;
  }

  .label {
    color: ${colors.g04};
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 4px;
    text-align: center;
  }

  .subtitle {
    font-size: 12px;
    text-align: center;
    color: ${colors.g04};
  }

  &:hover {
    box-shadow: 0px 2px 4px #0000001a;
  }
`;

const KitWrapper = styled.div`
  width: 827px;
`;

const CardsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: calc(100% + 16px);
  margin: -16px 0 40px -16px;
`;

function AgentKit({ history }) {
  const [activeItem, setActiveItem] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    localStorage.setItem(SKIP_AGENT_KIT_NEXT_LOGIN, true);
  }, []);

  const openModal = index => {
    setActiveItem(index);
    setIsVisible(true);
  };

  return (
    <KitWrapper>
      <Title>Agent Kit</Title>
      <Subtitle>
        Welcome to the Agent Kit. On this page, you will find the information that you need to start
        working.
      </Subtitle>
      <CardsWrapper>
        {cardsList.map((cardItem, index) => (
          <Card
            data-test={`card-item-${index}`}
            key={cardItem.title}
            onClick={() => openModal(index)}
          >
            <Image width="88px" height="88px" src={cardItem.icon} />
            <span className="label">{cardItem.title}</span>
            <span className="subtitle">{cardItem.subtitle}</span>
          </Card>
        ))}
      </CardsWrapper>
      <ButtonsWrapper>
        <FaqText>
          Questions? Go to our&nbsp;
          <LinkText
            target="_blank"
            href="https://help.neevo.ai/en/collections/2215581-dialogue-collection-jobs"
          >
            FAQ
          </LinkText>
          .
        </FaqText>
        <Button data-test="go-dashboard-button" onClick={() => history.push(ROUTES.HOME)}>
          Go to dashboard
        </Button>
      </ButtonsWrapper>
      <KitCarousel
        data-test="kit-carousel"
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
    </KitWrapper>
  );
}

AgentKit.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default AgentKit;
